import { Conductor, Program } from "src/models";
import { Promotions } from "src/models/promotions";

export type ProgramsConductor = {
  loading: boolean;
  offset: number;
  count: number;
  hasMore: boolean;
  list: Conductor[];
  featured: Program[];
  promotions?: Promotions;
  totalRecords: number;
  firstLoad: boolean;
};

export const ProgramsConductorInitialState: ProgramsConductor = {
  loading: false,
  offset: 0,
  count: 100,
  hasMore: true,
  list: [],
  featured: [],
  totalRecords: 0,
  firstLoad: true,
};
